module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTY0MCA4OTZhMzIgMzIgMCAwIDEgMCA2NGgtMjU2YTMyIDMyIDAgMCAxIDAtNjRoMjU2ek01MTIgOTZjMTc2LjcgMCAzMjAgMTQzLjMgMzIwIDMyMGEzMjAgMzIwIDAgMCAxLTE3NiAyODUuOFY4MDBhMzIgMzIgMCAwIDEtMzIgMzJoLTIyNGEzMiAzMiAwIDAgMS0zMi0zMnYtOTguMUEzMjAgMzIwIDAgMCAxIDE5MiA0MTZDMTkyIDIzOS4zIDMzNS4zIDk2IDUxMiA5NnoiIGZpbGw9IiMwIiBwLWlkPSI1MTA4Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Idea-filled.svg
// module id = ljvF
// module chunks = 74